<template>
  <div class="container page" style="width: 100%;height: 100%;background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;">
    <div class="header">
      <van-nav-bar :title="$t('auth.msg38')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#000" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-empty v-if="list.length === 0" :description="$t('auth.msg46')" />
          <div style="justify-content: space-between;display: flex;-webkit-box-align: center;align-items: center;-webkit-box-pack: justify;" v-else class="item_list" v-for="(v,key) in list" :key="key">
            <div>
				<div style="font-size:14px;font-weight: 600;color: #333;margin-top:16px">
					{{v.update_time}}
				</div>
				<div>
					<div style="padding:5px 15px;background-color: #9cce6d;color: #fff;text-align: center;border-radius:10px;font-size: 12px;margin-top: 16px;">
						{{$t('auth.msg45')}}
					</div>
				</div>
			</div>
			<div>
				<div style="padding:5px 15px;background-color: #9cce6d;color: #fff;text-align: center;border-radius:10px;font-size: 12px;margin-top: 16px;">
					+{{v.profit}}
				</div>
			</div>
          </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list:[]
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("auth.msg38"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList(){
      this.$http({
        method: 'get',
        url: 'user_get_win_list'
      }).then(res=>{
        if(res.code === 200){
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}

.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #ff253f;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{
  float: right;
}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}.nav-bar{background: unset;color:#000}::v-deep  .van-nav-bar__title{color:#000}

</style>
